<div class="clamav-file-lookup-container" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
    <div class="file-search">
        <div class="tam-form-field-filename" [ngClass]="{'has-error':name.invalid}">
            <label class="required">{{'general.filename' | stringLiterals}}</label>
            <input [(ngModel)]="filename" class="tam-input tam-textbox filename" type="text" value="filename"
                [formControl]="name">
            <button class="btn" (click)="onSubmit($event)" tam-button [tamType]="'primary'">{{'general.submit' |
                stringLiterals}}
            </button>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
    </div>
    <div class="file" *ngIf="isShowFileMessage || isShowFileDetail">
        <div class="file-info" *ngIf="isShowFileMessage">
            <div class="message" *ngFor="let item of messages"><span>{{item}}</span></div>
        </div>
        <div class="file-detail" *ngIf="isShowFileDetail">
            <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs"
                [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
    </div>
</div>